import React, { useCallback, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useResponseFormHandler } from 'src/utils/hooks/useResponseFormHandler';
import { useFetch } from 'src/utils/hooks/useFetch';
import { NewContactForm } from './NewContactForm';
import { GuestApi } from 'src/api/base/Guest';
import { ICreateGuestInfo, ICreateGuestModel, IGuestInfo } from 'src/api/base/Guest/types';
import { setGuest } from 'src/store/createGuest/slice';
import { RootState } from 'src/store';
import { NewContactCreateForm } from './NewContactCreateForm';
import { useSnackbar } from 'notistack';
import { APP_ROUTES } from 'src/routing/AppRoutes';
import { useHistory } from 'react-router';

type PNewContactFormContainer = {
  onSuccess?: (guest: ICreateGuestModel) => void;
  guest?: IGuestInfo | null;
};

export const NewContactFormCreate: React.FC<PNewContactFormContainer & { saveRef: React.MutableRefObject<null> }> = (
  props,
) => {
  const { saveRef } = props;
  const dispatch = useDispatch();
  const history = useHistory();
  const { enqueueSnackbar } = useSnackbar();

  const storedGuest = useSelector((state: RootState) => state.createGuest.guest);
  const [{ isLoading }, doFetch] = useFetch<any, any>(GuestApi.addGuestAvatar);
  const [mediaFiles, setMediaFiles] = useState<{
    imagesFormData: FormData;
    videosFormData: FormData;
  }>({
    imagesFormData: new FormData(),
    videosFormData: new FormData(),
  });
  const [isGuest, setIsGuest] = useState<boolean>(false);
  const [loading, setLoading] = useState<boolean>(false);
  useEffect(() => {
    const url = window.location.pathname;
    setIsGuest(url === "/guests/new-guest/create");
  }, []);



  const navigateToOverview = (id: number) => {
    const redirectUrl = isGuest ? APP_ROUTES.FN_GUEST_DETAILS_OVERVIEW(id) : APP_ROUTES.FN_CONTACT_DETAILS_OVERVIEW(id);
    history.push(redirectUrl);
  };

  const createContact = async (data: ICreateGuestModel) => {
    try {
      const { data: response } = await GuestApi.createGuest(data);
      const newGuestId = response.data.id;
      const successMsg = response.message || "Guest created successfully";

      if (storedGuest?.avatar) {
        doFetch({ id: newGuestId, formData: storedGuest.avatar });
      }

      await Promise.all([
        GuestApi.addGuestImages({ id: newGuestId, data: mediaFiles.imagesFormData }),
        GuestApi.addGuestVideo({ id: newGuestId, data: mediaFiles.videosFormData })
      ]);

      enqueueSnackbar(successMsg, { variant: 'success' });
      navigateToOverview(newGuestId)

    } catch (error) {
      enqueueSnackbar("Failed to complete guest creation", { variant: 'error' });
    } finally {
      setLoading(false);
    }
  };

  return (
    // <NewContactForm
    //   onSubmit={(data) => {
    //     // set guest data to redux
    //     dispatch(setGuest(data));
    //     onSuccess(data);
    //     // doFetch(data);
    //   }}
    //   errors={{}}
    //   loading={false}
    //   guest={storedGuest}
    //   submitBtnText="Next"
    //   isCreatingForm
    // />

    <NewContactCreateForm
      onSubmit={(data) => {
        // set guest data to redux
        if(loading) return;
        setLoading(true);
        dispatch(setGuest({ ...storedGuest, data }));
        createContact(data);
        // doFetch(data);
      }}
      onUpdateAvatar={(formData: FormData) => dispatch(setGuest({ ...storedGuest, avatar: formData }))
      }
      onUpdateImagesFormData={(formData: FormData) => {
        setMediaFiles((prev) => ({ ...prev, imagesFormData: formData }));
      }}
      onUpdateVideosFormData={(formData: FormData) => {
        setMediaFiles((prev) => ({ ...prev, videosFormData: formData }));
      }}
      errors={{}}
      loading={false}
      guest={storedGuest}
      isCreatingForm
      saveRef={saveRef}
    />
  );
};

export const NewContactFormUpdate: React.FC<PNewContactFormContainer> = (
  props,
) => {
  const { onSuccess, guest } = props;
  const [{ response, isLoading, error }, doFetch] = useFetch<any, any>(
    GuestApi.updateGuest,
  );

  useResponseFormHandler({ error, response });

  useEffect(() => {
    if (response) {
      onSuccess(response?.data?.data);
    }
  }, [response, onSuccess]);

  return (
    <NewContactForm
      onSubmit={(data) => {
        doFetch({ id: data?.id, data });
      }}
      errors={error?.response?.data?.errors}
      loading={isLoading}
      guest={guest}
    />
  );
};
